import axios from 'axios';
import { arrayIncludes } from '@shared/utils/arrays';
export async function downloadOnlineFile(request, open = false) {
    var _a;
    const axiosInstance = (this !== null && this !== void 0 ? this : axios);
    const requestConfig = typeof request === 'string' ? { url: request } : request;
    const response = await axiosInstance.request({
        responseType: 'blob',
        ...requestConfig,
    });
    const file = response.data;
    if (open)
        return openFile(file);
    const contentDisposition = parseContentDisposition(response.headers['content-disposition']);
    if (contentDisposition.type === 'inline')
        return openFile(file);
    const filename = (_a = contentDisposition.filename) !== null && _a !== void 0 ? _a : '';
    return downloadFile(file, filename);
}
export function downloadFile(data, filename) {
    const url = URL.createObjectURL(data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}
export function openFile(data) {
    const url = URL.createObjectURL(data);
    const win = window.open(url, '_blank');
    const interval = setInterval(() => {
        if (win === null || win === void 0 ? void 0 : win.closed) {
            clearInterval(interval);
            URL.revokeObjectURL(url);
        }
    }, 500);
}
export function parseContentDisposition(header) {
    if (!header)
        return { type: 'inline' };
    const [type, ...params] = header.split(';').map((part) => part.trim());
    if (!arrayIncludes(['inline', 'attachment'], type)) {
        throw new Error(`Unknown Content-Disposition type: ${type}`);
    }
    if (type === 'inline')
        return { type: 'inline' };
    let filename = null;
    for (const param of params) {
        const [key, value] = param.split('=');
        if (key.trim() === 'filename')
            filename = parseFilenameValue(value);
    }
    return { type: 'attachment', filename };
}
// Content-Disposition filenames may be quoted (`filename="chiffrage.pdf"`) or a bare
// RFC token (`filename=reporting.csv`, as emitted by Symfony HeaderUtils::makeDisposition
// for simple names). JSON.parse only handles the quoted form and throws on the bare token,
// so accept both: strip surrounding quotes when present, otherwise use the raw token.
// See: backend/src/PreparedExport/PreparedExportResponseFactory.php (makeDisposition)
function parseFilenameValue(value) {
    if (value === undefined)
        return null;
    const raw = value.trim().split(';')[0].trim();
    if (raw === '')
        return null;
    if (raw.startsWith('"') && raw.endsWith('"'))
        return JSON.parse(raw);
    return raw;
}
